
import RoutesComponent from '@/routes';

function App() {
  return <RoutesComponent />
}

export default App; 